import i18n from '@/lang';

// 代理-性质
export const natureOptions = [
  { id: '1', label: i18n.t('common.company') }, // 公司
  { id: '6', label: i18n.t('common.personalAccountCompany') }, // 个人账户公司
  { id: '2', label: i18n.t('common.person') }, // 个人
  { id: '3', label: i18n.t('common.studio') }, // 工作室
  { id: '4', label: i18n.t('common.internationalSchool') }, // 国际学校
  { id: '5', label: i18n.t('common.other') }, // 其他
];


export const getInstitutionInfos = (lang: string) => {
  switch (lang) {
    case 'zh':
      return institutionInfosZh;
    case 'zh-hk':
      return institutionInfosHK;
    case 'en-US':
      return institutionInfosEn;
    default:
      return institutionInfosEn;
  }
}
const institutionInfosZh: any[] = [
  {
    name: '澳洲及新西兰',
    imgUrl: require('@/assets/image/resource/aus.png'),
    linkInfo: [
      {
        institution: '澳洲院校',
        typeName: '申请指引及申请费',
        link: 'https://www.kdocs.cn/l/coyfg0HpoJzh',
      },
      {
        institution: '澳洲院校',
        typeName: '申请费',
        // link: 'https://www.kdocs.cn/l/cnTpGGoeChvH',
        link: 'applicationFee',
        countryId: 6,
        infoType: 1
      },
      {
        institution: '澳洲院校',
        typeName: '接受的语言类型',
        // link: 'https://www.kdocs.cn/l/ctZSR8vQMhTp',
        link: 'languageReq',
        countryId: 6,
        infoType: 2
      },
    ],
  },
  {
    name: '英国',
    imgUrl: require('@/assets/image/resource/uk.png'),
    linkInfo: [
      {
        institution: '英国院校',
        typeName: '申请指引及申请费',
        link: 'https://www.geaworld.org/UK_Guideline.html',
      },
      {
        institution: '英国院校',
        typeName: '申请费',
        // link: 'https://www.geaworld.org/UK_AppFee.html',
        link: 'applicationFee',
        countryId: 7,
        infoType: 1
      },
    ],
  },
  {
    name: '爱尔兰',
    imgUrl: require('@/assets/image/resource/ireland.png'),
    linkInfo: [
      {
        institution: '爱尔兰院校',
        typeName: '申请指引及申请费',
        link: 'https://www.geaworld.org/Ireland_Guideline.html',
      },
      {
        institution: '爱尔兰院校',
        typeName: '申请费',
        link: 'applicationFee',
        countryId: 23  ,
        infoType: 1
      },
    ],
  },
  {
    name: '加拿大',
    imgUrl: require('@/assets/image/resource/ca.png'),
    linkInfo: [
      {
        institution: '加拿大院校',
        typeName: '申请指引及申请费',
        link: 'https://www.geaworld.org/Can_Guideline.html',
      },
      {
        institution: '加拿大院校',
        typeName: '申请费',
        link: 'applicationFee',
        countryId: 5,
        infoType: 1
      },
    ],
  },
  {
    name: '美国',
    imgUrl: require('@/assets/image/resource/us.png'),
    linkInfo: [
      {
        institution: '美国院校',
        typeName: '申请指引及申请费',
        link: 'https://www.geaworld.org/USA_Guideline.html',
      },
      {
        institution: '美国院校',
        typeName: '申请费',
        link: 'applicationFee',
        countryId: 4,
        infoType: 1
      },
    ],
  },
];

const institutionInfosHK: any[] = [
  {
    name: '澳洲及新西蘭',
    imgUrl: require('@/assets/image/resource/aus.png'),
    linkInfo: [
      {
        institution: '澳洲院校',
        typeName: '申請指引及申請費',
        link: 'https://www.kdocs.cn/l/coyfg0HpoJzh',
      },
      {
        institution: '澳洲院校',
        typeName: '申請費',
        // link: 'https://www.kdocs.cn/l/cnTpGGoeChvH',
        link: 'applicationFee',
        countryId: 6,
        infoType: 1
      },
      {
        institution: '澳洲院校',
        typeName: '接受的語言類型',
        // link: 'https://www.kdocs.cn/l/ctZSR8vQMhTp',
        link: 'languageReq',
        countryId: 6,
        infoType: 2
      },
    ],
  },
  {
    name: '英國',
    imgUrl: require('@/assets/image/resource/uk.png'),
    linkInfo: [
      {
        institution: '英國院校',
        typeName: '申請指引及申請費',
        link: 'https://www.geaworld.org/UK_Guideline.html',
      },
      {
        institution: '英國院校',
        typeName: '申請費',
        // link: 'https://www.geaworld.org/UK_AppFee.html',
        link: 'applicationFee',
        countryId: 7,
        infoType: 1
      },
    ],
  },
  {
    name: '愛爾蘭',
    imgUrl: require('@/assets/image/resource/ireland.png'),
    linkInfo: [
      {
        institution: '愛爾蘭院校',
        typeName: '申請指引及申請費',
        link: 'https://www.geaworld.org/Ireland_Guideline.html',
      },
      {
        institution: '愛爾蘭院校',
        typeName: '申請費',
        link: 'applicationFee',
        countryId: 23  ,
        infoType: 1
      },
    ],
  },
  {
    name: '加拿大',
    imgUrl: require('@/assets/image/resource/ca.png'),
    linkInfo: [
      {
        institution: '加拿大院校',
        typeName: '申請指引及申請費',
        link: 'https://www.geaworld.org/Can_Guideline.html',
      },
      {
        institution: '加拿大院校',
        typeName: '申請費',
        link: 'applicationFee',
        countryId: 5,
        infoType: 1
      },
    ],
  },
  {
    name: '美國',
    imgUrl: require('@/assets/image/resource/us.png'),
    linkInfo: [
      {
        institution: '美國院校',
        typeName: '申請指引及申請費',
        link: 'https://www.geaworld.org/USA_Guideline.html',
      },
      {
        institution: '美國院校',
        typeName: '申請費',
        link: 'applicationFee',
        countryId: 4,
        infoType: 1
      },
    ],
  },
];

const institutionInfosEn: any[] = [
  {
    name: 'Australia and New Zealand',
    imgUrl: require('@/assets/image/resource/aus.png'),
    linkInfo: [
      {
        institution: 'Universities and colleges in Australia',
        typeName: 'Application guide and Fee',
        link: 'https://www.kdocs.cn/l/coyfg0HpoJzh',
      },
      {
        institution: 'Universities and colleges in Australia',
        typeName: 'Application fee',
        // link: 'https://www.kdocs.cn/l/cnTpGGoeChvH',
        link: 'applicationFee',
        countryId: 6,
        infoType: 1
      },
      {
        institution: 'Universities and colleges in Australia',
        typeName: 'Accepted language types',
        // link: 'https://www.kdocs.cn/l/ctZSR8vQMhTp',
        link: 'languageReq',
        countryId: 6,
        infoType: 2
      },
    ],
  },
  {
    name: 'United Kingdom',
    imgUrl: require('@/assets/image/resource/uk.png'),
    linkInfo: [
      {
        institution: 'Institutions in the United Kingdom',
        typeName: 'Application guide and Fee',
        link: 'https://www.geaworld.org/UK_Guideline.html',
      },
      {
        institution: 'Institutions in the United Kingdom',
        typeName: 'Application fee',
        // link: 'https://www.geaworld.org/UK_AppFee.html',
        link: 'applicationFee',
        countryId: 7,
        infoType: 1
      },
    ],
  },
  {
    name: 'Ireland',
    imgUrl: require('@/assets/image/resource/ireland.png'),
    linkInfo: [
      {
        institution: 'Colleges and universities in Ireland',
        typeName: 'Application guide and Fee',
        link: 'https://www.geaworld.org/Ireland_Guideline.html',
      },
      {
        institution: 'Colleges and universities in Ireland',
        typeName: 'Application fee',
        link: 'applicationFee',
        countryId: 23  ,
        infoType: 1
      },
    ],
  },
  {
    name: 'Canada',
    imgUrl: require('@/assets/image/resource/ca.png'),
    linkInfo: [
      {
        institution: 'Colleges and universities in Canada',
        typeName: 'Application guide and Fee',
        link: 'https://www.geaworld.org/Can_Guideline.html',
      },
      {
        institution: 'Colleges and universities in Canada',
        typeName: 'Application fee',
        link: 'applicationFee',
        countryId: 5,
        infoType: 1
      },
    ],
  },
  {
    name: 'America',
    imgUrl: require('@/assets/image/resource/us.png'),
    linkInfo: [
      {
        institution: 'American colleges and universities',
        typeName: 'Application guide and Fee',
        link: 'https://www.geaworld.org/USA_Guideline.html',
      },
      {
        institution: 'American colleges and universities',
        typeName: 'Application fee',
        link: 'applicationFee',
        countryId: 4,
        infoType: 1
      },
    ],
  },
];
